import React from "react";

import { Fade } from "react-reveal";

import "./styles.css";

const appMockup = require("../../../../assets/images/propertymanagement/propertymanagement_image4.png");

const workflowItems = [
  {
    title: "Incident reporting",
    copy: "Capture reports, notes, photos, details, timestamps, and relevant location context in a consistent workflow.",
  },
  {
    title: "Centralized intake",
    copy: "Create internal intake or reporting paths that route information to the right people for review and follow-up.",
  },
  {
    title: "Role-based awareness",
    copy: "Help appropriate team members stay informed without making every report visible to every user.",
  },
  {
    title: "Places and tagging",
    copy: "Organize activity by service area, facility, school, shelter, Tribal partner, outreach location, or other configured place.",
  },
  {
    title: "Reporting and export",
    copy: "Review activity, track program visibility, and export information that supports operational and outcome reporting.",
  },
  {
    title: "Safety workflows",
    copy: "Use GuardMe, Check-In, and other safety-related workflows where they genuinely fit staff outreach or field response.",
  },
];

const Ability = () => {
  return (
    <Fade bottom>
      <section className="rural_ability_container">
        <div className="rural_ability_media">
          <img
            className="rural_ability_image"
            src={appMockup}
            alt="See It Send It mobile incident reporting"
          />
          <div className="rural_ability_media_note">
            <span className="h2-sb text-white">Configured workflows</span>
            <p className="h4-r text-white">
              Build around your service model, reporting needs, user roles, and
              partner visibility.
            </p>
          </div>
        </div>
        <div className="rural_ability_content">
          <div className="rural_support_header">
            <span className="h2-sb text-primary">
              How See It Send It supports victim-service programs
            </span>
            <h1 className="h1-b text-white">
              Practical tools for intake, awareness, and documentation
            </h1>
            <p className="h3-m text-white">
              See It Send It gives campus and university teams a practical way
              to collect, route, document, and review safety-related information
              without adding another disconnected process.
            </p>
          </div>
          <div className="rural_workflow_grid">
            {workflowItems.map((item) => (
              <article className="rural_workflow_card" key={item.title}>
                <h2 className="h2-sb text-white">{item.title}</h2>
                <p className="h4-r text-white">{item.copy}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </Fade>
  );
};

export default Ability;
